import type { Tour } from '../tour-state.js';

// Journey B: shows the app around a new user, then walks through their first job. The bubbles have
// Next and the targets only explain, so they're passive, except the first job, which a click opens.
// With no job to open, the job steps are left out.
const hasJob = (context: { hasJob?: boolean }) => !!context.hasJob;

// Opening the first job and the steps that point inside its card; closing the card (the browser's
// Back) sends the tour back to opening it
export const JOB_STEPS = ['open-job', 'job-content', 'job-collapse', 'job-complete'];

const welcome: Tour = {
  id: 'welcome',
  steps: [
    {
      id: 'side-bar',
      targets: ['side-bar'],
      text: 'This menu takes you around nodeStream: your feed, workflows, supply chain, org chart and relationships.',
      advance: 'next',
      passive: true,
    },
    {
      // The whole page first: the job list, the company and the activity, with the bubble under the title
      id: 'feed-page',
      targets: ['feed-page'],
      anchor: 'page-title',
      placement: 'bottom-start',
      text: "This is your feed: your jobs on the left, your company in the middle, and what's happened recently on the right.",
      advance: 'next',
      passive: true,
    },
    {
      id: 'company-summary',
      targets: ['company-summary'],
      text: 'This is your company on nodeStream: its details and how far its verification has got.',
      advance: 'next',
      passive: true,
    },
    {
      id: 'company-switcher',
      targets: ['company-switcher'],
      text: 'If you work for more than one company, switch between them here.',
      advance: 'next',
      passive: true,
    },
    {
      id: 'feed',
      targets: ['feed'],
      text: 'Your feed lists everything waiting for you. Each card is a job: a task for you to do.',
      advance: 'next',
      passive: true,
    },
    {
      id: 'activity',
      targets: ['feed-activity'],
      text: "What's happened recently at your company, newest first.",
      advance: 'next',
      passive: true,
    },
    {
      id: 'open-job',
      targets: ['first-job'],
      text: 'Click your first job to open it.',
      advance: 'next',
      onNext: 'open-first-job',
      doneOn: ['job-opened'],
      when: hasJob,
    },
    {
      id: 'job-content',
      targets: ['job-body'],
      text: 'This is the job itself: the details and the steps it needs from you.',
      advance: 'next',
      passive: true,
      when: hasJob,
    },
    {
      id: 'job-collapse',
      targets: ['job-collapse'],
      text: 'Close the job here to go back to your feed. Your progress is kept.',
      advance: 'next',
      passive: true,
      when: hasJob,
    },
    {
      // The job card's action bar, which every job renders its own buttons into (job-container.ts)
      id: 'job-complete',
      targets: ['job-actions'],
      text: "When you've done everything the job asks, complete it with the buttons here. The next job appears in your feed when it's ready.",
      advance: 'next',
      passive: true,
      when: hasJob,
    },
  ],
};

export default welcome;
